import { render } from "./ProjectParallax.vue?vue&type=template&id=b9cf114e&scoped=true"
import script from "./ProjectParallax.vue?vue&type=script&lang=js"
export * from "./ProjectParallax.vue?vue&type=script&lang=js"

import "./ProjectParallax.vue?vue&type=style&index=0&id=b9cf114e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9cf114e"]])

export default __exports__